import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum GroupStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  ON_HOLD = 3,
  RETIRED = 4,
}

export function getGroupStatii(): ISelectItem[] {
  return [
    { id: 1, label: 'Pending' },
    { id: 2, label: 'Active' },
    { id: 3, label: 'On Hold' },
    { id: 4, label: 'Retired' },
  ]
}

export const getGroupStatusByLabel = getItemByLabelFactory(getGroupStatii)
export const getGroupStatusById = getItemByIdFactory(getGroupStatii)
